import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import React from 'react';

import { isSSR } from '@/utility/isSSR';
import { isUrlAbsolute } from '@/utility/isUrlAbsolute';

import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import css from './Hero.module.css';
import HeroImages from './HeroImages';

const Hero = ({ title, subtitle, buttonUrl: rawButtonUrl, buttonLabel, heroImg } = {}) => {
  let buttonUrl = rawButtonUrl;
  if (buttonUrl && !isSSR()) {
    if (!isUrlAbsolute(buttonUrl)) {
      buttonUrl = new URL(buttonUrl, document.baseURI).href;
    }
  }
  return (
    <div className={css.hero}>
      <div className={`py-6 px-4 lg:p-20 w-100 lg:pl-0  ${css.main}`}>
        <h1 className="text-3xl font-medium leading-tight md:text-4xl">{title}</h1>
        <h2 className="mt-4 text-xl text-gray-500">{subtitle}</h2>
        {buttonUrl && (
          <Button
            className="mt-4"
            variant={EButtonColorVariant.Primary}
            label={buttonLabel}
            fullWidth
            href={buttonUrl}
          />
        )}
      </div>
      <div
        className={`w-100 h-100 min-w-auto mt-0 md:mt-4 self-center  ${css.aside} overflow-hidden`}>
        {heroImg && (
          <ResponsiveImage
            className="md:rounded"
            src={heroImg}
            alt={title || ''}
            priority={true}
            withFetchPriority="high"
          />
        )}
        {!heroImg && <HeroImages />}
      </div>
    </div>
  );
};

export default Hero;
